module.exports = __webpack_public_path__ + "img/Sin título_1.5.1.dcbe984d.jpg";